import { useQuery } from "@tanstack/react-query";
import {
  fetchActivityCounters,
  FetchActivityCountersPayload
} from "PFCore/services/workflow_inbox/activity_counters";
import { QueryOptions } from "PFTypes/request_options";
import { ActivityCounters } from "PFTypes/workflow_inbox";

import { activityCountersKeys } from "./query_keys";

export const useActivityCounters = (
  params: FetchActivityCountersPayload,
  options: QueryOptions<ActivityCounters> = {}
) =>
  useQuery<ActivityCounters>({
    queryKey: activityCountersKeys.list(params),
    queryFn: () => fetchActivityCounters(params),
    ...options
  });
